import { Route, Switch } from "react-router";
import { AppRouteUi } from "../../../config/appRoute";
import { PageAppointmentView } from "./pageAppointmentView";
import { PageAppointmentAdd } from "./pageAppointmentAdd";
import { PageAppointmentUpdate } from "./pageAppointmentUpdate";
import { PageBackdatedInvoiceGeneration } from "./pageBackdatedInvoiceGeneration";
import { RedirectRoute } from "../../../components/redirectRoute";

export function PageAppointment(): JSX.Element {
  return (
    <div className="">
      <Switch>
        <Route
          path={AppRouteUi.Appointment.List()}
          exact
          component={PageAppointmentView}
        />
        <Route
          path={AppRouteUi.Appointment.Add()}
          exact
          component={PageAppointmentAdd}
        />
        <Route
          path={AppRouteUi.Appointment.Update()}
          exact
          component={PageAppointmentUpdate}
        />
        <Route
          path={`${AppRouteUi.Appointment.Root()}/backdated-invoice/:appointmentId`}
          exact
          component={PageBackdatedInvoiceGeneration}
        />
        <RedirectRoute
          from={AppRouteUi.Appointment.Root()}
          to={AppRouteUi.Appointment.List()}
          wildcardOpt={{
            defaultTo404Page: true,
          }}
        />
      </Switch>
    </div>
  );
}
